import { IEditorV3 } from "./interface";
import { isIEditorV3Line } from "./isIEditorV3Line";

/**
 * Type guard for the editor structure
 *
 * Determine whether a value matches the `IEditorV3` shape used by the
 * editor domain. This checks that `obj` is an object containing a `lines`
 * array and that each entry matches the `IEditorV3Line` predicate.
 *
 * @param obj - The value to test for `IEditorV3` compatibility
 * @returns True when `obj` conforms to `IEditorV3`, otherwise false
 */
export const isIEditorV3 = (obj: unknown): obj is IEditorV3 => {
  return (
    // Check object
    typeof obj === "object" &&
    obj !== null &&
    // Check properties exist
    "lines" in obj &&
    // Check properties types
    Array.isArray((obj as IEditorV3).lines) &&
    (obj as IEditorV3).lines.every((line) => isIEditorV3Line(line))
  );
};
